import axios from "axios";
import { ENDPOINTS } from "./endpoints";

const { WEEKLY_DIARY, LESSON_PLAN } = ENDPOINTS;

// Drop empty values so they are not sent as `?key=`
const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined),
  );

/**
 * One row per teacher + subject for a week (reviewer view).
 * @param {{ week_start: string, status?: string, search?: string }} params - week_start is the Monday, yyyy-MM-dd
 */
export const getDiaryOverview = (params) =>
  axios.get(WEEKLY_DIARY.OVERVIEW, { params: cleanParams(params) });

/**
 * A teacher's diary for one subject and week, with its lessons.
 * @param {{ teacher_id: number, subject_id: number, week_start: string, status?: string, search?: string }} params
 */
export const getDiary = (params) => axios.get(WEEKLY_DIARY.GET, { params: cleanParams(params) });

/** Teacher closes the week. @param {{ subject_id: number, week_start: string, reflection: string }} data */
export const submitDiary = (data) => axios.post(WEEKLY_DIARY.SUBMIT, data);

/** Reviewer approves. @param {{ teacher_id: number, subject_id: number, week_start: string, remarks: string }} data */
export const approveDiary = (data) => axios.post(WEEKLY_DIARY.APPROVE, data);

/** Reviewer tags a lesson. @param {{ review_tag: "follow_up" | "needs_attention" | null }} data */
export const updateLessonReviewTag = (lessonPlanId, data) =>
  axios.put(`${LESSON_PLAN.UPDATE}/${lessonPlanId}/${LESSON_PLAN.REVIEW_TAG}`, data);
